var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 87.9798C81.1834 87.9798 84.98 84.1832 84.98 79.4998C84.98 74.8164 81.1834 71.0198 76.5 71.0198C71.8166 71.0198 68.02 74.8164 68.02 79.4998C68.02 84.1832 71.8166 87.9798 76.5 87.9798Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.55 53L63.7005 58.3H55.3C52.385 58.3 50 60.685 50 63.6V95.4C50 98.315 52.385 100.7 55.3 100.7H97.7C100.615 100.7 103 98.315 103 95.4V63.6C103 60.685 100.615 58.3 97.7 58.3H89.2995L84.45 53H68.55ZM76.5 92.75C69.186 92.75 63.25 86.814 63.25 79.5C63.25 72.186 69.186 66.25 76.5 66.25C83.814 66.25 89.75 72.186 89.75 79.5C89.75 86.814 83.814 92.75 76.5 92.75Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.c048d33518cf7804d049a96420fa42cb.svg";
export { ForwardRef as ReactComponent };